const semanticTokens = {
  colors: {
    "bg.main": {
      default: "white",
      _dark: "gray.900",
    },
    "bg.high": {
      default: "gray.50",
      _dark: "gray.800",
    },
    "bg.higher": {
      default: "gray.100",
      _dark: "gray.700",
    },
    "bg.highest": {
      default: "gray.200",
      _dark: "gray.600",
    },
    "bg.contrast": {
      default: "gray.800",
      _dark: "gray.100",
    },
    "bg.primary": {
      default: "primary.700",
      _dark: "primary.400",
    },
    "bg.danger": {
      default: "red.50",
      _dark: "red.200",
    },
    border: {
      default: "gray.200",
      _dark: "gray.700",
    },
    "border.soft": {
      default: "gray.100",
      _dark: "gray.700",
    },
    text: {
      default: "gray.800",
      _dark: "gray.200",
    },
    "text.primary": {
      default: "primary.500",
      _dark: "primary.200",
    },
    "text.contrast": {
      default: "gray.100",
      _dark: "gray.800",
    },
    "text.contrast.soft": {
      default: "gray.200",
      _dark: "gray.600",
    },
    "text.soft": {
      default: "gray.600",
      _dark: "gray.300",
    },
    "text.softer": {
      default: "gray.400",
      _dark: "gray.500",
    },
    "text.softest": {
      default: "gray.200",
      _dark: "gray.500",
    },
    "pageheader.border": {
      default: "gray.200",
      _dark: "gray.700",
    },
    "sidebar.bg": {
      default: "primary.500",
      _dark: "primary.400",
    },
    "sidebar.bg.admin": {
      default: "gray.900",
      _dark: "gray.900",
    },
    "sidebar.bg.active": {
      default: "primary.400",
      _dark: "primary.300",
    },
    "sidebar.bg.inactive": {
      default: "gray.100",
      _dark: "gray.700",
    },
    "sidebar.border": {
      default: "primary.200",
      _dark: "gray.700",
    },
    "sidebar.text": {
      default: "gray.100",
      _dark: "gray.200",
    },
    "table.bg.header": {
      default: "primary.500",
      _dark: "primary.400",
    },
    "table.bg.subheader": {
      default: "primary.300",
      _dark: "primary.600",
    },
    "table.text": {
      default: "gray.100",
      _dark: "gray.200",
    },
    "table.border": {
      default: "gray.200",
      _dark: "gray.700",
    },
    "table.border.soft": {
      default: "gray.100",
      _dark: "gray.800",
    },
    warning: {
      default: "yellow.200",
      _dark: "yellow.400",
    },
    info: {
      default: "cyan.400",
      _dark: "cyan.100",
    },
    action: {
      default: "primary.400",
      _dark: "primary.100",
    },
    success: {
      default: "green.400",
      _dark: "green.100",
    },
    danger: {
      default: "red.500",
      _dark: "red.300",
    },
  },
};

export default semanticTokens;
